import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { mask } from 'remask';
import moment from 'moment';
import { instanceAxios } from '../../InstanceAxios';
import 'moment/locale/pt-br';
import { isEmpty } from '../../utils/common';
import { CAMPO_OBRIGATORIO } from '../../consts/common';

function Pessoal({ cliente, handleUpdateClient }) {
  const TelefonePattern = ['(99)99999-9999'];
  const CPFPattern = ['999.999.999-99'];
  const RGPattern = ['99.999.999-9'];
  const [segmentos, setSegmentos] = useState([]);
  const [errorNome, setErrorNome] = useState(!cliente.nome);
  const [errorTelefone, setErrorTelefone] = useState(!cliente.telefone);

  const isValid = (en, et) => !en && !et;

  useEffect(() => {
    const fetchUsernames = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/segmentosatuacao`)
        .then((res) => {
          setSegmentos(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchUsernames();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="nome"
          label="Nome"
          variant="outlined"
          value={cliente.nome}
          onChange={(event) => {
            const obj = cliente;
            obj.nome = event.target.value;
            setErrorNome(isEmpty(event.target.value));
            handleUpdateClient(
              obj,
              isValid(isEmpty(event.target.value), errorTelefone)
            );
          }}
          error={errorNome}
          helperText={CAMPO_OBRIGATORIO}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="email"
          label="Email"
          variant="outlined"
          value={cliente.email}
          disabled
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="cpf"
          label="CPF"
          variant="outlined"
          value={mask(cliente.cpf, CPFPattern)}
          disabled
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="rg"
          label="RG"
          variant="outlined"
          value={mask(cliente.rg, RGPattern)}
          onChange={(event) => {
            const obj = cliente;
            obj.rg = event.target.value;
            handleUpdateClient(obj, isValid(errorNome, errorTelefone));
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="nomeMae"
          label="Nome Mãe"
          variant="outlined"
          value={cliente.nome_mae}
          onChange={(event) => {
            const obj = cliente;
            obj.nome_mae = event.target.value;
            handleUpdateClient(obj, isValid(errorNome, errorTelefone));
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          id="sexo"
          variant="outlined"
          select
          label="Sexo"
          value={cliente.sexo}
          onChange={(event) => {
            const obj = cliente;
            obj.sexo = event.target.value;
            handleUpdateClient(obj, isValid(errorNome, errorTelefone));
          }}
        >
          <MenuItem key="Masculino" value="Masculino">
            Masculino
          </MenuItem>
          <MenuItem key="Feminino" value="Feminino">
            Feminino
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={3}>
        <TextField
          id="telefone"
          label="Telefone"
          variant="outlined"
          value={mask(cliente.telefone, TelefonePattern)}
          onChange={(event) => {
            const obj = cliente;
            obj.telefone = event.target.value;
            setErrorTelefone(isEmpty(event.target.value));
            handleUpdateClient(
              obj,
              isValid(errorNome, isEmpty(event.target.value))
            );
          }}
          error={errorTelefone}
          helperText={CAMPO_OBRIGATORIO}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          disabled
          id="createdAt"
          label="Dia do Cadastro"
          variant="outlined"
          value={moment(cliente.createdAt).format('l')}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          id="segmentoatuacao"
          variant="outlined"
          select
          label="Segmento"
          value={cliente.id_segmento_atuacao}
          onChange={(event) => {
            const obj = cliente;
            obj.id_segmento_atuacao = event.target.value;
            handleUpdateClient(obj, isValid(errorNome, errorTelefone));
          }}
        >
          {segmentos.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.nome}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
}

export default Pessoal;
